export default "__VITE_ASSET__BZLhA8bW__"